// extracted by mini-css-extract-plugin
export default {"timer":"FyheUgIL5D_nBSJ1Nf3r"};